// Compressed, explorable interpretation of CDMX; stable ids preserve progress.
export const mexicoLandmarks = [
  {id:0,name:'Reforma Tower',area:'Paseo de la Reforma',x:-25,z:-23,description:'Sculpted glass towers above a jacaranda-lined boulevard.'},
  {id:1,name:'Bellas Artes Palace',area:'Centro Histórico',x:13,z:-20,description:'White marble arcades crowned by a copper and amber dome.'},
  {id:2,name:'Chapultepec Castle',area:'Bosque de Chapultepec',x:-29,z:22,description:'A terraced hilltop castle surrounded by wooded gardens.'},
  {id:3,name:'Zócalo Cathedral',area:'Plaza de la Constitución',x:27,z:11,description:'Carved stone bell towers looking over the great civic square.'},
  {id:4,name:'Xochimilco Gardens',area:'Xochimilco canals',x:27,z:42,description:'Colorful trajineras drift between planted islands and flower gardens.'},
] as const
export const mexicoAddresses:Record<number,[number,number]> = {
  1:[-47,-43],3:[-47,-30],6:[-47,-17],8:[-47,-1],9:[-47,10],11:[-47,24],13:[-47,42],
  14:[46,-43],16:[46,-29],18:[46,-15],19:[46,0],21:[46,16],23:[46,33],24:[46,48],
  26:[-30,-45],27:[-1,-45],29:[12,-45],31:[25,-45],33:[-37,48],34:[-23,48],36:[-10,48],38:[30,-30],
}
export const mexicoTileNames:Record<number,string> = {
  0:'BIENVENIDOS',1:'MADERO',3:'TACUBA',5:'METRO',6:'DONCELES',8:'REGINA',9:'MONEDA',
  10:'ALAMEDA',11:'PASEO REFORMA',13:'INSURGENTES',14:'JUÁREZ',15:'METRO',16:'ÁLVARO OBREGÓN',18:'COLIMA',19:'ORIZABA',
  20:'FIESTA',21:'ÁMSTERDAM',23:'MICHOACÁN',24:'TAMAULIPAS',25:'METRO',26:'MASARYK',27:'HORACIO',29:'HOMERO',
  30:'CHAPULTEPEC',31:'UNIVERSIDAD',33:'FRANCISCO SOSA',34:'CENTENARIO',35:'METRO',36:'XOCHIMILCO',38:'NATIVITAS',
}
export function mexicoPropertyPosition(id:number):[number,number]{
  if(id<100){const p=mexicoLandmarks[id];return [p.x,p.z]}
  return mexicoAddresses[id-100]??[0,0]
}
export function mexicoLanePose(time:number,index:number,lane:number){
  const progress=((index/7+time*2.4/102)%1+1)%1,reverse=lane<0,long=(progress-.5)*102*(reverse?-1:1),angle=Math.atan(.2)
  return {x:-8+Math.sin(angle)*long+Math.cos(angle)*lane,z:Math.cos(angle)*long-Math.sin(angle)*lane,angle:angle+(reverse?Math.PI:0),scale:Math.min(1,progress*30,(1-progress)*30)}
}
export function mexicoBoatPose(time:number,index:number){
  const progress=((Math.floor(index/2)/2+time*.42/20)%1+1)%1,direction=index%2?1:-1
  return {x:2+(progress-.5)*20*direction,z:direction*1.35,angle:direction*Math.PI/2,scale:Math.min(1,progress*25,(1-progress)*25)}
}
